export function StorySection() {
  const timelineEvents = [
    {
      year: '2024',
      title: 'CommerceMinder yazılım şirketi kuruldu.',
      description:
        'Pazaryeri altyapısı ve çekirdek platform mimarisi oluşturuldu.',
    },
    {
      year: '2025',
      title: 'İlk B2B ve pazaryeri projeleri canlıya alındı.',
      description: 'ERP, ödeme ve kargo entegrasyon altyapıları geliştirildi.',
    },
    {
      year: '2026',
      title: 'Mobil uygulama ve ölçeklenebilir SaaS çözümleri genişletildi.',
      description: 'Global pazara yönelik teknoloji yatırımları başlatıldı.',
    },
  ];

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @media (max-width: 768px) {
            .mobile-story-section {
              padding-top: 40px !important;
              padding-bottom: 40px !important;
              flex-direction: column !important;
              gap: 32px !important;
            }
            .mobile-story-container {
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
            .mobile-story-content {
              position: relative !important;
              height: auto !important;
              flex-direction: column !important;
              gap: 32px !important;
            }
            .mobile-story-left {
              width: 100% !important;
              padding-right: 0 !important;
              padding-bottom: 0 !important;
              position: static !important;
            }
            .mobile-story-title {
              font-size: 24px !important;
              line-height: 32px !important;
            }
            .mobile-story-description {
              font-size: 14px !important;
              line-height: 22px !important;
            }
            .mobile-story-right {
              width: 100% !important;
              padding-left: 0 !important;
              position: static !important;
            }
            .mobile-story-timeline {
              gap: 24px !important;
            }
            .mobile-story-line {
              display: none !important;
            }
            .mobile-story-dot {
              display: none !important;
            }
          }
        `,
        }}
      />
      <div className="w-full py-[40px] bg-slate-950 flex flex-col justify-center items-center mobile-story-section">
        <div className="w-full max-w-[1200px] px-[60px] flex flex-col gap-12 mobile-story-container">
          <div className="w-full flex justify-start items-center gap-3">
            <div
              className="size-2.5 rounded-[3px]"
              style={{ background: '#76BCE8' }}
            />
            <div className="inline-flex flex-col justify-start items-start">
              <div
                className="justify-center text-xs font-semibold font-['Inter'] uppercase tracking-widest"
                style={{ color: 'rgba(255, 255, 255, 0.5)' }}
              >
                Hikayemiz
              </div>
            </div>
          </div>

          <div className="w-full h-96 relative mobile-story-content">
            <div className="w-[539.50px] pr-12 pb-24 left-0 top-[-0.71px] absolute inline-flex flex-col justify-start items-start gap-4 mobile-story-left">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div
                  className="self-stretch justify-center text-3xl font-bold font-['Inter'] leading-10 mobile-story-title"
                  style={{ color: '#FAFAFA' }}
                >
                  Sıfırdan sektörün
                  <br />
                  altyapısına
                </div>
              </div>
              <div className="self-stretch pt-2 flex flex-col justify-start items-start">
                <div
                  className="self-stretch justify-center text-base font-normal font-['Inter'] leading-7 mobile-story-description"
                  style={{ color: 'rgba(255, 255, 255, 0.5)' }}
                >
                  CommerceMinder, e-ticaret altyapısının ne kadar dağınık ve
                  <br />
                  maliyetli olduğunu bizzat yaşayan bir ekip tarafından kuruldu.
                </div>
              </div>
              <div className="self-stretch pb-[0.75px] flex flex-col justify-start items-start">
                <div
                  className="self-stretch justify-center text-base font-normal font-['Inter'] leading-7 mobile-story-description"
                  style={{ color: 'rgba(255, 255, 255, 0.5)' }}
                >
                  Sipariş yönetimi, kargo, ERP ve pazaryeri entegrasyonlarını
                  <br />
                  ayrı ayrı yönetmek zorunda kalan işletmeler için hepsini tek
                  <br />
                  çatı altında toplayan bir platform inşa ettik.
                </div>
              </div>
            </div>

            <div className="w-[539.50px] pl-12 left-[540.50px] top-0 absolute inline-flex flex-col justify-start items-start mobile-story-right">
              <div className="self-stretch pt-2 flex flex-col justify-start items-start gap-9 mobile-story-timeline">
                {timelineEvents.map((event, index) => (
                  <div
                    key={index}
                    className="self-stretch inline-flex justify-start items-start gap-5"
                  >
                    <div className="size- min-w-12 pr-3.5 pt-0.5 inline-flex flex-col justify-start items-start">
                      <div
                        className="justify-center text-sm font-bold font-['Inter']"
                        style={{ color: '#9DD0F0' }}
                      >
                        {event.year}
                      </div>
                    </div>
                    <div className="size- inline-flex flex-col justify-start items-start gap-1">
                      <div className="self-stretch flex flex-col justify-start items-start">
                        <div
                          className="justify-center text-sm font-bold font-['Inter']"
                          style={{ color: '#FAFAFA' }}
                        >
                          {event.title}
                        </div>
                      </div>
                      <div className="self-stretch flex flex-col justify-start items-start">
                        <div
                          className="justify-center text-xs font-normal font-['Inter'] leading-5"
                          style={{ color: 'rgba(255, 255, 255, 0.25)' }}
                        >
                          {event.description}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="w-px h-96 left-[539.50px] top-0 absolute mobile-story-line"
              style={{
                background:
                  'linear-gradient(to bottom, #76BCE8, rgba(118, 188, 232, 0.1))',
              }}
            >
              <div
                className="size-2 left-[-4px] top-0 absolute rounded-sm mobile-story-dot"
                style={{
                  background: '#76BCE8',
                  boxShadow: '0px 0px 12px 0px rgba(118, 188, 232, 0.40)',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
